import {createEffectFn} from '@ngneat/effects';
import {catchError, debounceTime, distinctUntilChanged, EMPTY, Observable, switchMap} from 'rxjs';

import {suppliersService} from '@store/suppliers/suppliers.service';
import {ClientsState} from '@store/clients';

type SearchSuppliersParams = Partial<ClientsState>

export const searchSuppliersEffect = createEffectFn((params$: Observable<SearchSuppliersParams>) => {
  return params$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(() => suppliersService.getSuppliers().pipe(catchError(() => EMPTY))),
  );
});
